module.exports = __webpack_public_path__ + "img/step2.c9a11d50.png";